import React, { Component } from "react";
import moment from "moment";
import { Card, SearchBox } from "@evertrue/et-components";
import _ from "underscore";
import PropTypes from "prop-types";
import { WithPromises } from "../contexts/api-context";
import { CachedContactsPreLoader, CachedContactsProvider } from "../contexts/cached-contacts-context";
import { VolunteerSessionProvider } from "../contexts/volunteer-session-context";
import { WithMixPanelEvents } from "../contexts/mixpanel-context";
import VolunteerSolicitorResolver from "../contexts/volunteer-solicitor-resolver";
import VolunteerStatsTable from "./volunteer-stats-table";
import AnalyticsDataResolver from "./analytics-data-resolver";
import RespondTo from "./respond-to";

class VolunteersStatsTableController extends Component {
  static propTypes = {
    pool: PropTypes.object,
    promises: PropTypes.object.isRequired,
    limit: PropTypes.number,
    mixPanelEvents: PropTypes.object.isRequired,
    isVMSApp: PropTypes.bool,
    lastUpdatedAt: PropTypes.number,
    isHeadAgentEnabled: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool,
    orgFiscalYear: PropTypes.string,
    stagesForGroup: PropTypes.array,
    hasStagesFeature: PropTypes.bool,
  };

  static defaultProps = {
    limit: 50,
    interval: 50,
    tableFlexBasis: "60vh",
    pool: {},
    mixPanelEvents: {},
  };

  state = {
    name_query: "",
    sortBy: "name_last",
    sortOrder: true,
  };

  debouncedSearch = _.debounce(name_query => {
    this.setState({ name_query });
  }, 300);

  handleSort = sortBy => {
    this.setState(state => ({
      sortOrder: !state.sortOrder,
      sortBy,
    }));
    this.props.mixPanelEvents.sortByColumns({ sortField: sortBy });
  };

  render() {
    const {
      pool,
      promises,
      orgFiscalYear,
      isVMSApp,
      lastUpdatedAt,
      limit,
      isMobile,
      hasStagesFeature,
      stagesForGroup,
    } = this.props;
    const { sortBy, sortOrder } = this.state;
    const sort_order_string = sortOrder ? "asc" : "desc";

    return (
      <CachedContactsProvider fetchContactsById={promises.fetchContactsById}>
        <VolunteerSessionProvider fetchSessionsByContactId={promises.fetchSessionsByContactId}>
          <AnalyticsDataResolver
            nameQuery={this.state.name_query}
            poolId={pool.id}
            sortBy={sortBy}
            sortOrder={sort_order_string}
            promises={promises}
            limit={limit}
            isMobile={isMobile}
          >
            {({ data: { items = [], total }, loading, page, handlePageChange }) => {
              const contact_ids = items.map(item => item.solicitor_contact_id);
              return (
                <React.Fragment>
                  <CachedContactsPreLoader contactIds={contact_ids} />
                  {/* this kicks of a fetch in a provider up top */}
                  <VolunteerSolicitorResolver children={() => null} contactIds={contact_ids} poolId={pool.id} />
                  <RespondTo
                    component={Card}
                    className="volunteers-stats-table--main"
                    header={
                      <RespondTo className="volunteers-stats-table--header">
                        <RespondTo className="volunteers-stats-table--top-section">
                          {!isMobile && <span className="volunteers-stats-table--heading">Volunteers</span>}
                          {lastUpdatedAt && (
                            <RespondTo className="volunteers-stats-table--last-updated">
                              Report Data Last Refreshed: {moment(lastUpdatedAt).format("MM/DD/YYYY h:mm a")}
                            </RespondTo>
                          )}
                        </RespondTo>

                        <RespondTo
                          component={SearchBox}
                          className="volunteers-stats-table--search"
                          value={this.state.name_query}
                          onChange={this.debouncedSearch}
                          placeholder="Search for Volunteer by Name..."
                        />
                      </RespondTo>
                    }
                  >
                    <VolunteerStatsTable
                      pool={pool}
                      isVMSApp={isVMSApp}
                      orgFiscalYear={orgFiscalYear}
                      items={items}
                      total={total}
                      limit={limit}
                      loading={loading}
                      handlePageChange={handlePageChange}
                      sortOrder={sortOrder}
                      interval={this.props.interval}
                      sortBy={sortBy}
                      handleSort={this.handleSort}
                      page={page}
                      tableFlexBasis={this.props.tableFlexBasis}
                      isHeadAgentEnabled={this.props.isHeadAgentEnabled}
                      isMobile={this.props.isMobile}
                      hasStagesFeature={hasStagesFeature}
                      stagesForGroup={stagesForGroup}
                      renderActivityCount={this.props.renderActivityCount}
                      renderAssignmentCount={this.props.renderAssignmentCount}
                    />
                  </RespondTo>
                </React.Fragment>
              );
            }}
          </AnalyticsDataResolver>
        </VolunteerSessionProvider>
      </CachedContactsProvider>
    );
  }
}

export default WithMixPanelEvents(WithPromises(VolunteersStatsTableController));
